import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import PartnersCard from './PartnersCard';
import { CardList, CardSlider } from '../widgets/DataRenderer';
import LinkBack from '../widgets/LinkBack';

import './partners.scss';

class PartnersTemplate extends PureComponent {
  render() {
    const { title, subtitle, meta } = this.props.content;

    const settings = {
      slidesToShow: 4
    };

    const items = this.props.content.items.map(item => {
      const props = {
        ...item,
        id: item.id,
        onClick: this.props.onCardClick
      };

      return <PartnersCard {...props} />;
    });

    const ListComponent = this.props.isMobile ? CardList : CardSlider;

    return (
      <div className="partners">
        {(meta) &&
          <Helmet>
            <title>{meta.title}</title>
          </Helmet>
        }

        <div className="partners-content">
          <div className="container">
            <LinkBack link="/we/subnavigation/">
              мы <i>вернуться</i>
            </LinkBack>

            <h1 dangerouslySetInnerHTML={{ __html: title }} />
            <p dangerouslySetInnerHTML={{ __html: subtitle }} />
          </div>

          <div className="data-renderer-container">
            <div className="container">
              <ListComponent items={items} settings={settings}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PartnersTemplate.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        logo: PropTypes.string,
        label: PropTypes.string,
        site: PropTypes.string
      })
    ),
    meta: PropTypes.shape({
      title: PropTypes.string
    })
  }),
  isMobile: PropTypes.bool,
  onCardClick: PropTypes.func
};

export default PartnersTemplate;



// WEBPACK FOOTER //
// ./src/components/Partners/PartnersTemplate.js